import { h } from 'preact'
import FirebaseComponent from './FirebaseComponent'
import * as firebase from 'firebase'

class UpdateEmail extends FirebaseComponent {
  constructor() {
    super()
    this.state = { email: '', loading: false }
    this.handleValueChange = this.handleValueChange.bind(this)
    this.updateEmail = this.updateEmail.bind(this)
    this.loadingSpinner = this.loadingSpinner.bind(this)
  }

  loadingSpinner() {
    if (this.state.loading) return <i className="fa fa-spinner fa-spin" style={{ 'font-size': '24px' }}></i>
  }

  handleValueChange(event) {
    this.setState({[event.target.name]: event.target.value})
  }

  updateEmail(event) {
    event.preventDefault()
    this.setState({ loading: true })

    const uid = firebase.auth().currentUser.uid

    try {
    firebase.auth().currentUser.updateEmail(this.state.email)
      .then(() => {
        firebase.database().ref(`profiles/${uid}/email`)
          .set(this.state.email)
          .then(() => {
            this.setState({ email: '', loading: false, message: 'Updated Email' })
          })
      })
    } catch (error) {
      this.setState({ message: error.message, loading: false })
    }

  }

  render() {
    return (
      <div>
        <form>
          <div className="form-group">
            <input
              name="email"
              className="form-control"
              onChange={this.handleValueChange}
              placeholder="New Email Address"
              value={this.state.email}
            />
          </div>
          <button
            className="btn btn-primary btn-sm btn-block"
            onClick={this.updateEmail}
            type="submit">{this.loadingSpinner()} UPDATE EMAIL</button>
          {this.state.message}
        </form>
      </div>
    )
  }
}

export default UpdateEmail



// WEBPACK FOOTER //
// ./src/UpdateEmail.js